import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

export const container = css`
  display: flex;
`

export const containerSize = (theme: Theme) => ({
  small: css`
    width: ${theme.spacing[16]};
    height: ${theme.spacing[16]};

    ${breakpoint.up('sm')} {
      width: ${theme.spacing[20]};
      height: ${theme.spacing[20]};
    }
  `,
  medium: css`
    width: ${theme.spacing[20]};
    height: ${theme.spacing[20]};

    ${breakpoint.up('sm')} {
      width: ${theme.spacing[24]};
      height: ${theme.spacing[24]};
    }
  `,
})
